import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {
  Avatar,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Stack,
  Tooltip
} from '@mui/material';
import { Box, color } from '@mui/system';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { RiAccountPinCircleFill } from 'react-icons/ri';

function ApplicationHeader() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <CssBaseline />
      <Box className="mainHeader">
        <Container maxWidth="lg">
          <Stack>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              sx={{
                alignItems: 'center'
              }}
            >
              <Grid
                item
                xs={8}
                sx={{
                  alignItems: 'center'
                }}
              >
                <Link href="/dashboard">
                  <img
                    // src="/static/logos/lessEMI-logo-w.svg"
                    // src="/static/logos/kalolyticLogoW.svg"
                    src="/static/logos/kalolyticLogo.svg"
                    className="mainLogo"
                    alt="Logo"
                    style={{ height: '40px' }}
                  />
                </Link>
              </Grid>
              {/* <Grid item xs={4} className="userIconBox">
                <Tooltip title="Account settings">
                  <Link
                    onClick={handleClick}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="userLink"
                  >
                    <RiAccountPinCircleFill className="userIcon" />
                  </Link>
                </Tooltip>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1
                      },
                      '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 12,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0
                      }
                    }
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleClose}>My account</MenuItem>
                  <MenuItem onClick={handleClose}>Logout</MenuItem>
                </Menu>
              </Grid> */}
            </Grid>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
export default ApplicationHeader;
